export default "__VITE_ASSET__0e834f78__"